<app-sidebar>
  <app-sidebar-menu-item title="Reservations" routeLink="/operations/reservations" iconStyles="fa fa-car fa-fw" />
  <app-sidebar-menu-item
    title="Rental Agreements"
    routeLink="/operations/rental-agreements"
    iconStyles="fa fa-handshake fa-fw" />
</app-sidebar>
<div class="d-flex flex-fill">
  <router-outlet />
</div>
